module.exports = __webpack_public_path__ + "static/media/Bigi2.a820b45e.jpeg";